import { useFreePushups } from '@hook/useFreePushups';
import { FreePushUpInfoModal } from '@components/FreePushUpInfoModal';

interface Props {
  isOpen: boolean,
  onClose: () => void,
}

export const FreePushUpInfoModalContainer: React.FC<Props> = ({
  isOpen,
  onClose,
}) => {
  const { freePushupsLimit } = useFreePushups();

  if (freePushupsLimit) {
    return (
      <FreePushUpInfoModal
        isOpen={isOpen}
        limit={freePushupsLimit}
        onClose={onClose}
      />
    );
  }

  return null;
};
